/** @format */
import { useEffect, useState } from 'react';
import { error } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';
import useQuery from '../../../Shared/queryString';

const normalizeSelectValue = (value) =>
  value === null || value === undefined ? '' : String(value);

const List = ({
  field,
  onChangeValue,
  eventContext,
  teamForm,
  queryParameter,
  getCities,
  cityLoading,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(() => normalizeSelectValue(field?.value));

  useEffect(() => {
    setSelected(normalizeSelectValue(field?.value));
  }, [field?.value, field?.name]);

  useEffect(() => {
    const getOptions = async () => {
      setLoading(true);
      let params = '';
      if (field?.parameters != undefined && field?.parameters?.length > 0) {
        field?.parameters?.forEach((param) => {
          let query = useQuery.getParam(param);
          params += `${params.length == 0 ? '?' : '&'}${param}=${query}`;
        });
      }

      if (field?.name === 'sid') {
        await useApi.get(
          '/position?no-paginate=true',
          {},
          (res) => {
            const data = res.data?.data ?? [];
            setOptions(
              data.map((item) => ({
                key: item.id,
                value: item.name,
              })),
            );
            setLoading(false);
          },
          () => {
            setLoading(false);
            error('خطا در دریافت لیست سمت‌ها');
          },
        );
        return;
      }

      if (
        field?.name == 'field_id' &&
        eventContext?.event?.fields?.length > 0
      ) {
        setOptions(eventContext?.event?.fields ?? []);
        setLoading(false);
        return;
      }
      await useApi.get(
        field?.relation + params,
        {},
        (res) => {
          let data = res.data.data;
          if (field.name == 'province_id') {
            data = data.filter(
              (d) => d.name !== 'سراسری' && d.name !== 'فدراسیون',
            );
          }
          setOptions(data);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
          error('خطا در دریافت اطلاعات استان ها');
        },
      );
    };
    if (field?.name === 'sid' || (field?.relation !== undefined && field?.name != 'city_id')) {
      getOptions();
    }
  }, [field]);

  const getOptions = () => {
    if (field?.name == 'city_id') {
      return eventContext?.cities;
    }
    if (field?.name === 'sid') {
      return options.length > 0 ? options : field.options ?? [];
    }
    if (field?.relation === undefined) {
      return field.options;
    }
    return options;
  };

  return cityLoading && field?.name == 'city_id' ? (
    <div className='form-group d-flex flex-column'>
      <label>{field.label}</label>
      <div className='form-group d-flex flex-row justify-content-center align-items-center'>
        <div
          className='spinner-border spinner-border-sm text-white mb-1'
          role='status'
        ></div>
      </div>
    </div>
  ) : (
    <div className='form-group d-flex flex-column'>
      <label>{field.label}</label>
      {loading ? null : (
        <select
          value={selected}
          className='form-control f-13'
          onChange={(e) => {
            const nextValue = e.target.value;
            setSelected(nextValue);
            if (field?.name == 'province_id' && getCities != null) {
              getCities(nextValue);
            }
            onChangeValue(field.name, nextValue, teamForm);
          }}
        >
          <option value=''>انتخاب کنید</option>
          {(getOptions() ?? []).map((item) => {
            const optionValue = normalizeSelectValue(
              item?.key === undefined ? item.id : item?.key,
            );
            return (
            <option
              key={optionValue}
              value={optionValue}
            >
              {item?.value === undefined && item?.title === undefined
                ? item.name
                : item?.value === undefined && item?.name === undefined
                ? item?.title
                : item?.value}
            </option>
            );
          })}
        </select>
      )}
    </div>
  );
};

export default List;
